import '@updater-components/icon';
import template from './verify.html';
import './verify.global.css';

export const VerifyComponent = {
  template,
};
